unit UOverviewConfig;

interface

uses
  UColumnList;

type
  TOverviewConfig = class
  private
    FLastStamps: Boolean;
    FStampsCount: Integer;
    FForwardAccounts: Boolean;
    FSelectedForwardAccounts: string;
    FNotice: Boolean;
    FMonthOverview: Boolean;
    FMonthCount: Integer;
    FColumnList: TColumnList;
    procedure ClearValues;
    procedure SetValues(json: string);
    procedure SetLastStamps(const Value: Boolean);
    procedure SetStampsCount(const Value: Integer);
    procedure SetForwardAccounts(const Value: Boolean);
    procedure SetSelectedForwardAccounts(const Value: string);
    procedure SetNotice(const Value: Boolean);
    procedure SetMonthOverview(const Value: Boolean);
    procedure SetMonthCount(const Value: Integer);
    procedure SetColumnList(const Value: TColumnList);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property LastStamps: Boolean read FLastStamps write SetLastStamps;
    property StampsCount: Integer read FStampsCount write SetStampsCount;
    property ForwardAccounts: Boolean read FForwardAccounts write SetForwardAccounts;
    property SelectedForwardAccounts: string read FSelectedForwardAccounts write SetSelectedForwardAccounts;
    property Notice: Boolean read FNotice write SetNotice;
    property MonthOverview: Boolean read FMonthOverview write SetMonthOverview;
    property MonthCount: Integer read FMonthCount write SetMonthCount;
    property ColumnList: TColumnList read FColumnList write SetColumnList;
  end;

implementation

uses
  Js, UEssentialHelper, System.SysUtils;

{ TOverviewConfig }

procedure TOverviewConfig.ClearValues;
begin
  Self.LastStamps:=false;
  Self.StampsCount:=0;
  Self.ForwardAccounts:=false;
  Self.SelectedForwardAccounts:='';
  Self.Notice:=false;
  Self.MonthOverview:=false;
  Self.MonthCount:=3;
  Self.ColumnList:=TColumnList.Create;
end;

constructor TOverviewConfig.Create;
begin
  Self.ClearValues;
end;

constructor TOverviewConfig.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TOverviewConfig.SetColumnList(const Value: TColumnList);
begin
  FColumnList := Value;
end;

procedure TOverviewConfig.SetForwardAccounts(const Value: Boolean);
begin
  FForwardAccounts := Value;
end;

procedure TOverviewConfig.SetLastStamps(const Value: Boolean);
begin
  FLastStamps := Value;
end;

procedure TOverviewConfig.SetMonthCount(const Value: Integer);
begin
  FMonthCount := Value;
end;

procedure TOverviewConfig.SetMonthOverview(const Value: Boolean);
begin
  FMonthOverview := Value;
end;

procedure TOverviewConfig.SetNotice(const Value: Boolean);
begin
  FNotice := Value;
end;

procedure TOverviewConfig.SetSelectedForwardAccounts(const Value: string);
begin
  FSelectedForwardAccounts := Value;
end;

procedure TOverviewConfig.SetStampsCount(const Value: Integer);
begin
  FStampsCount := Value;
end;

procedure TOverviewConfig.SetValues(json: string);
var obj: TJsObject;
begin
  Self.ClearValues;
  obj:=TJsJson.parseObject(json);
  if obj['LastStamps']<>nil then
    Self.LastStamps:=StrToBoolean(string(obj['LastStamps']));
  if obj['StampsCount']<>nil then
    Self.StampsCount:=StrToInt(string(obj['StampsCount']));
  if obj['ForwardAccounts']<>nil then
    Self.ForwardAccounts:=StrToBoolean(string(obj['ForwardAccounts']));
  if obj['SelectedForwardAccounts']<>nil then
    Self.SelectedForwardAccounts:=string(obj['SelectedForwardAccounts']);
  if obj['Notice']<>nil then
    Self.Notice:=StrToBoolean(string(obj['Notice']));
  if obj['MonthOverview']<>nil then
    Self.MonthOverview:=StrToBoolean(string(obj['MonthOverview']));
  if obj['MonthCount']<>nil then
    Self.MonthCount:=StrToInt(string(obj['MonthCount']));
  if obj['ColumnList']<>nil then
    Self.ColumnList.FromJson(string(obj['ColumnList']));
end;

end.
